import axios from 'axios';
// import LogRocket from 'logrocket';
import $ from 'jquery';
import Backbone from 'backbone';
import Cookies from 'js-cookie';

import Constants from '../config/constants';
import { addQuarters, addSeconds } from 'date-fns';

export default class Provider extends Backbone.Model {
	urlRoot = Constants.API_URL + '/providers';

	url() {
		return this.urlRoot + '/' + this.id;
	}

	fetch(options) {
		var extendedOptions = { ...options };
		extendedOptions.data = extendedOptions.data || {};
		extendedOptions.data.filter = JSON.stringify({
			include: [
				{
					relation: 'provider_practice',
				},
			],
		});
		return Backbone.Model.prototype.fetch.call(this, extendedOptions);
	}

	logout() {
		// $.post(this.urlRoot + '/logout').always(() => {
		// 	this.resetSession();
		// });
		axios.post(`${this.urlRoot}/logout`).finally(() => {
			this.resetSession();
		});
	}

	resetSession() {
		// if (process.env.NODE_ENV && process.env.NODE_ENV !== 'production') {
		// 	LogRocket.startNewSession();
		// }
		this.clear({
			silent: true,
		});
		this.set({
			loggedIn: false,
		});
		if ($.ajaxSetup.headers) {
			delete $.ajaxSetup.headers['Authorization'];
		}
		delete axios.defaults.headers.common['Authorization'];
		Cookies.remove(Constants.CCPID);
		Cookies.remove(Constants.CCPT);
	}

	checkAuth(callback = () => {}) {
		// verify cookie values and load user
		var accessToken = Cookies.get(Constants.CCPT);
		var userId;
		if (accessToken) {
			userId = Cookies.get(Constants.CCPID);
			this.fetch({
				url: this.urlRoot + '/' + userId,
				headers: {
					Authorization: accessToken,
				},
				success: (model, response) => {
					if (response.error) {
						// TODO show error?
						this.resetSession();
					} else {
						axios.defaults.headers.common['Authorization'] = accessToken;
						// axios.defaults.baseURL = Constants.API_URL;
						$.ajaxSetup({
							headers: {
								Authorization: accessToken,
							},
						});
						// if (process.env.NODE_ENV && process.env.NODE_ENV !== 'production') {
						// 	LogRocket.identify(userId);
						// }
						// this will trigger a change event to show main menu
						this.set({
							loggedIn: true,
						});
					}
				},
				error: () => {
					// TODO show error?
					this.resetSession();
				},
			}).always(callback);
		} else {
			this.resetSession();
			callback();
		}
	}

	login() {
		var url = this.urlRoot + '/login';
		$.ajaxSetup({
			headers: null,
		});
		return this.save(
			{},
			{
				url: url,
			}
		).then(() => {
			return this.prepUserForLogin();
		});
	}

	prepUserForLogin() {
		const tokenExpiresAt = addSeconds(
			new Date(this.get('created')),
			this.get('ttl')
		);

		// remove password from model
		this.unset('password');

		// set up auth headers
		$.ajaxSetup({
			headers: {
				Authorization: this.id,
			},
		});
		axios.defaults.headers.common['Authorization'] = this.id;

		// set cookie with token
		Cookies.set(Constants.CCPT, this.id, {
			expires: tokenExpiresAt,
		});
		Cookies.set(Constants.CCPID, this.get('userId'), {
			expires: tokenExpiresAt,
		});
		// if (process.env.NODE_ENV && process.env.NODE_ENV !== 'production') {
		// 	LogRocket.identify(this.get('userId'));
		// }

		// set username cookie if remember me was checked
		if (this.get('rememberMe')) {
			Cookies.set(Constants.CCPUSERNAME, this.get('email'), {
				expires: addQuarters(new Date(), 1),
			});
		} else {
			Cookies.remove(Constants.CCPUSERNAME);
		}

		// get account data
		this.set('id', this.get('userId'));
		return this.fetch().then(() => {
			this.set('loggedIn', true);
		});
	}

	forgotPassword() {
		var url = this.urlRoot + '/reset';
		// POST
		return this.save(
			{},
			{
				url,
			}
		);
	}

	resetPassword(access_code, email, password) {
		const url = `${this.urlRoot}/reset_user_password`;
		// POST
		// axios.post(url, {access_code, email, password});
		return this.save({ access_code, email, password }, { url });
	}

	changePassword(oldPassword, newPassword) {
		const url = `${this.urlRoot}/updatePassword`;
		// PUT
		return this.save(
			{ emailVerify: this.get('email'), oldPassword, newPassword },
			{ url }
		);
	}
}
